import { reputationRepository } from '../repositories/reputation-repository';
import { isValidDomain, isValidEmail, isValidURL } from '../shared/reputation-helpers';

async function checkReputation(string) {
    if (!string) {
        throw new Error('Empty field');
    };

    if (isValidDomain(string)) {
        return reputationRepository.checkDomain(string);
    };

    if (isValidURL(string)) {
        return reputationRepository.checkUrl(string);
    };

    if (isValidEmail(string)) {
        return reputationRepository.checkEmail(string);
    };

    throw new Error('Invalid domain, link or email');
};

export {
    checkReputation
};
